import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useRemoveStaticPartReplacement = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.removeStaticPartReplacement,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useRemoveStaticPartReplacement')
        .extras({errorDetails})
        .error('Error occurred while deleting a replacement for static part')

      spawnErrorToast(t('error.removeStaticPartReplacement'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['staticPartReplacement']})
      spawnSuccessToast(t('success.removeStaticPartReplacement'))
    }
  })
}
